import React from "react";
import pageNotFound from "../../assets/images/page-not-found.jpg";
import { getEnvironmentProperties } from "../common/environmentProperties";

const ServiceUnavailable = () => {
  const { fr: frenchMessageLines, en: englishMessageLines } =
    getEnvironmentProperties().additionalMessages || {};

  return (
    <div
      style={{
        width: "350px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div>
          <img
            src={pageNotFound}
            alt="Page Not Found"
            height="250px"
            width="250px"
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexAlign: "center",
          alignItems: "center",
          margin: "18px",
          flexDirection: "column",
        }}
      >
        {!!frenchMessageLines &&
          frenchMessageLines.map((m, i) => <p key={`line-${i}`}>{m}</p>)}
        <p>-</p>
        {!!englishMessageLines &&
          englishMessageLines.map((m, i) => <p key={`line-${i}`}>{m}</p>)}
      </div>
    </div>
  );
};

export default ServiceUnavailable;



// WEBPACK FOOTER //
// ./src/components/login/ServiceUnavailable.js